export default __webpack_public_path__ + "static/media/leg_murai.fba9ac5e.png";